import { IDatabaseUpgrade } from "../database-upgrade";
import { DatabaseUpgradeV6 } from "./database-upgrade-v6";
import { DatabaseUpgradeV7 } from "./database-upgrade-v7";
import { DatabaseUpgradeV8 } from "./database-upgrade-v8";
import { DatabaseUpgradeV9 } from "./database-upgrade-v9";
import { DatabaseUpgradeV10 } from "./database-upgrade-v10";
import { DatabaseUpgradeV11 } from "./database-upgrade-v11";
import { DatabaseUpgradeV12 } from "./database-upgrade-v12";
import { DatabaseUpgradeV13 } from "./database-upgrade-v13";
import { DatabaseUpgradeV14 } from "./database-upgrade-v14";
import { DatabaseUpgradeV15 } from "./database-upgrade-v15";
import { DatabaseUpgradeV16 } from "./database-upgrade-v16";
import { DatabaseUpgradeV17 } from "./database-upgrade-v17";

/**
 * Defines members for registering database upgrades and getting the latest database version.
 */
export class VersionRegistry {
	/**
	 * Private constructor to prevent this class from being instantiated because TypeScript doesn't support static classes.
	 */
	private constructor() { }

	/**
	 * Returns the list of database upgrades.
	 * @returns {IDatabaseUpgrade[]} The array of database upgrades.
	 */
	public static readonly Upgrades: IDatabaseUpgrade[] = [
		new DatabaseUpgradeV6(),
		new DatabaseUpgradeV7(),
		new DatabaseUpgradeV8(),
		new DatabaseUpgradeV9(),
		new DatabaseUpgradeV10(),
		new DatabaseUpgradeV11(),
		new DatabaseUpgradeV12(),
		new DatabaseUpgradeV13(),
		new DatabaseUpgradeV14(),
		new DatabaseUpgradeV15(),
		new DatabaseUpgradeV16(),
		new DatabaseUpgradeV17()
	];

	/**
	 * Returns the latest version of the database.
	 * @returns {number} The latest version number of the database.
	 */
	public static LatestVersionNumber(): number {
		const upgrades = VersionRegistry.Upgrades;
		return upgrades.length ? upgrades[upgrades.length - 1].Version : 1;
	}
}